<template>
  <div class="topup-form-frame">
    <div>
      <div v-if="isStatusSuccess()">
        <div class="text">
          <h2 style="text-align: center">Gotowe!</h2>
          <p v-html="getStatusDescription()"></p>
        </div>
        <div class="desc">
          <p class="bold"></p>
        </div>
        <div class="button">
          <button type='button' class="btn" @click="goToRegisterForm">
            Zarejestruj nową kartę SIM
          </button>
        </div>
      </div>
      <div v-if="isStatusPending()">
        <div class="text">
          <h2>Czekaj, trwa proces rejestracji...</h2>
          <p v-html="getStatusDescription()"></p>
        </div>
      </div>
      <div v-if="isStatusError()">
        <div class="text">
          <h2 style="text-align: center">Wystąpił błąd!</h2>
          <p v-html="getStatusDescription()"></p>
          <p>Zapraszamy do rejestracji w najbliższym Salonie Plus.</p>
        </div>
        <div class="desc">
          <p class="bold"></p>
        </div>
        <div class="button">
          <button type="button" class="btn" @click="goToRegisterForm">
            Spróbuj jeszcze raz
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  REGISTER_STATUS_DESCRIPTION,
  REGISTER_STATUS_ERROR,
  REGISTER_STATUS_PENDING,
  REGISTER_STATUS_SUCCESS
} from '@/common/const/registerSim.const'
import { ROUTING } from '@/sim-plus/const/routing.const'

export default {
  name: 'RegisterStatus',
  computed: {
    ...mapState({
      status: state => state.registersim.statusData?.status || state.registersim.errorData?.statusDescription
    })
  },
  methods: {
    goToRegisterForm () {
      this.$router.push(ROUTING.register).catch(() => {})
    },
    getStatusDescription () {
      return REGISTER_STATUS_DESCRIPTION[this.status]
    },
    isStatusPending () {
      return REGISTER_STATUS_PENDING.includes(this.status)
    },
    isStatusSuccess () {
      return REGISTER_STATUS_SUCCESS.includes(this.status)
    },
    isStatusError () {
      return REGISTER_STATUS_ERROR.includes(this.status)
    }
  }
}
</script>
<style src="../../assets/scss/topup-form.scss" lang="scss"></style>
